import React, { useState } from "react";
import { motion } from "framer-motion";
import Input from "../../app/components/Input";
import Button from "../../app/components/Button";
import { FiX } from "react-icons/fi";
import Select from "../../app/components/Select";
import SelectResponsible from "../../app/components/SelectResponsible";
import { z } from "zod";
import { emailSchema, phoneSchema, nomeSchema, formatPhone } from "../../Validations/schemas";


const ContactsAdd = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    nome: "",
    cargo: "",
    departamento: "",
    email: "",
    telefone: "",
  });


  const departmentOptions = [
    { value: "fiscal", label: "Fiscal" },
    { value: "contabil", label: "Contábil" },
    { value: "dp", label: "DP" },
    { value: "financeiro", label: "Financeiro" },
    { value: "sucesso_cliente", label: "Sucesso do Cliente" },
    { value: "comercial", label: "Comercial" },
    { value: "rh", label: "Recursos Humanos" },
    { value: "legalizacao", label: "Legalização" },
    { value: "gestao_risco", label: "Gestão de Riscos" },
    { value: "gestao_resultados", label: "Gestão para Resultados" },
    { value: "ordem_servico", label: "Ordens de Serviço" },
  ];

  const positionOptions = [
    { value: "adiministrador", label: "Adiministrador(a)" },
    { value: "assistente", label: "Assistente" },
    { value: "contador", label: "Contador" },
    { value: "diretor", label: "Diretor" },
    { value: "empresario", label: "Empresário" },
    { value: "financeiro", label: "Financeiro" },
    { value: "funcionario", label: "Funcionário(a)" },
    { value: "gerente", label: "Gerente" },
    { value: "gestor", label: "Gestor" },
    { value: "presidente", label: "Presidente" },
    { value: "recepicionista", label: "Recepicionista" },
    { value: "responsavel", label: "Responsável" },
  ];

  const [errors, setErrors] = useState({});

const handleChange = (field) => (valueOrEvent) => {
  const value = valueOrEvent?.target?.value ?? valueOrEvent;
  let formattedValue = value;

  if (field === "telefone") {
    formattedValue = formatPhone(value);
  }

  setFormData((prev) => ({ ...prev, [field]: formattedValue }));

  if (typeof formattedValue === 'string' && formattedValue.trim() === "") {
    setErrors((prev) => ({ ...prev, [field]: "" }));
    return;
  }

  try {
    if (field === "nome") {
      nomeSchema.parse(formattedValue);
      setErrors((prev) => ({ ...prev, nome: "" }));
    } else if (field === "email") {
      emailSchema.parse(formattedValue);
      setErrors((prev) => ({ ...prev, email: "" }));
    } else if (field === "telefone") {
      phoneSchema.parse(formattedValue);
      setErrors((prev) => ({ ...prev, telefone: "" }));
    }
  } catch (e) {
    if (e instanceof z.ZodError) {
      setErrors((prev) => ({ ...prev, [field]: e.errors[0].message }));
    }
  }
};


  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    setFormData({
      nome: "",
      cargo: "",
      departamento: "",
      email: "",
      telefone: "",
    });
  };

  const panelVariants = {
    hidden: { x: 400, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 300, damping: 30 },
    },
    exit: {
      x: 400,
      opacity: 0,
      transition: { duration: 0.2, ease: "easeInOut" },
    },
  };

  const handleChangeDepartamento = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      departamento: selectedOptions,
    }));
  };


  return (
    <motion.div
      className="fixed bottom-8 z-[999]"
      style={{ right: "500px", width: "400px" }}
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={panelVariants}
    >
      <div className="bg-white shadow-2xl rounded-2xl flex flex-col overflow-y-auto p-6 space-y-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-900">
            Adicionar Contato
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 p-1"
            aria-label="Fechar"
          >
            <FiX />
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          className="space-y-4 flex-1 flex flex-col justify-between"
        >
          <div className="space-y-4">
            <div>
              <Input
                label="Nome"
                value={formData.nome}
                onChange={handleChange("nome")}
                required
                error={!!errors.nome}
              />
              {errors.nome && <p className="text-red-500 text-sm mt-[-0.95rem]">{errors.nome}</p>}
            </div>

            <Select
              label="Cargo"
              value={formData.cargo}
              onChange={handleChange("cargo")}
              options={positionOptions}
            />
            <SelectResponsible
              label="Departamento"
              options={departmentOptions}
              value={formData.departamento}
              onChange={handleChangeDepartamento}
            />
            <div>
              <Input
                label="E-mail"
                value={formData.email}
                onChange={handleChange("email")}
                error={!!errors.email}
              />
              {errors.nome && <p className="text-red-500 text-sm mt-[-0.95rem]">{errors.email}</p>}
            </div>

            <div>
              <Input
                label="Telefone"
                value={formData.telefone}
                required
                onChange={handleChange("telefone")}
                error={!!errors.telefone}
              />
              {errors.nome && <p className="text-red-500 text-sm mt-[-0.95rem]">{errors.telefone}</p>}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 mt-6">
            <Button variant="secondary" onClick={onClose} type="button">
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Salvar
            </Button>
          </div>
        </form>
      </div>
    </motion.div>
  );
};

export default ContactsAdd;
